module.exports = __webpack_public_path__ + "static/img/eyes_12.f55d723.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/eyes/thumbnail/eyes_12.png
// module id = NqgD
// module chunks = 0